import React from 'react';
import { motion } from 'framer-motion';
import { Clock, GlassWater, Sparkles, Palmtree } from 'lucide-react';
import { useLanguage } from '../lib/LanguageContext';
export function SignaturePackage() {
  const {
    t
  } = useLanguage();
  const features = [{
    icon: <Clock className="w-6 h-6" data-id="element-99" />,
    title: t('package.f1.title'),
    desc: t('package.f1.desc')
  }, {
    icon: <GlassWater className="w-6 h-6" data-id="element-100" />,
    title: t('package.f2.title'),
    desc: t('package.f2.desc')
  }, {
    icon: <Sparkles className="w-6 h-6" data-id="element-101" />,
    title: t('package.f3.title'),
    desc: t('package.f3.desc')
  }, {
    icon: <Palmtree className="w-6 h-6" data-id="element-102" />,
    title: t('package.f4.title'),
    desc: t('package.f4.desc')
  }];
  return <section className="py-24 bg-[#F5EDE0] border-y border-amber-200/50" data-id="element-103">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-104">
        <div className="text-center mb-16" data-id="element-105">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-serif text-zinc-900 mb-4" data-id="element-106">
            {t('package.title.part1')}{' '}
            <span className="text-[#D4A843] italic" data-id="element-107">
              {t('package.title.part2')}
            </span>{' '}
            {t('package.title.part3')}
          </motion.h2>
          <motion.div initial={{
          opacity: 0,
          scaleX: 0
        }} whileInView={{
          opacity: 1,
          scaleX: 1
        }} viewport={{
          once: true
        }} className="w-24 h-[1px] bg-[#D4A843] mx-auto" data-id="element-108"></motion.div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-109">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} className="relative group" data-id="element-110">
            <div className="absolute -inset-4 bg-gradient-to-tr from-[#D4A843]/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 blur-xl" data-id="element-111"></div>
            <img src="https://cdn.magicpatterns.com/uploads/uH2BaVaLt6c9pcy2wF21mX/lisa1.jpg" alt="Tropical Elegance Bar Setup" className="w-full h-auto object-cover rounded-sm relative z-10 shadow-2xl" data-id="element-112" />
          </motion.div>

          <div className="space-y-8" data-id="element-113">
            {features.map((feature, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex items-start gap-6 group" data-id="element-114">
                <div className="flex-shrink-0 w-12 h-12 rounded-full border border-[#D4A843]/50 flex items-center justify-center text-[#0D9488] group-hover:bg-[#0D9488] group-hover:text-white group-hover:border-[#0D9488] transition-colors duration-300" data-id="element-115">
                  {feature.icon}
                </div>
                <div data-id="element-116">
                  <h3 className="text-xl font-serif text-zinc-900 mb-2" data-id="element-117">
                    {feature.title}
                  </h3>
                  <p className="text-zinc-600 font-light leading-relaxed" data-id="element-118">
                    {feature.desc}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}